module.exports = __webpack_public_path__ + "media/3.90608b53.mp3";